import React from "react";
import { Button, Col, ListGroup, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import { fireDb, fireStorage } from "../Firebase/Config";

const ListComp = () => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    const unsub = fireDb
      .collection("files")
      .orderBy("createdAt", "desc")
      .onSnapshot((snap) => {
        let documents = [];
        snap.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setDocs(documents);
      });

    return () => unsub();
    // this is a cleanup function that react will run when
    // a component using the hook unmounts
  }, []);

  // deletes from both Firebase storage and Firebase database
  const handleDelete = (url, id) => {
    if (window.confirm("Are you sure you wish to delete this item?")) {
      let fileRef = fireStorage.refFromURL(url);
      fileRef.delete();
      fireDb.collection("files").doc(id).delete();
    }
  };

  return (
    <>
      {docs.length > 0 && (
        <ListGroup className="list mt-3 w-100">
          <h2 className="list_title">UPLOADED FILES...</h2>
          <ListGroup.Item className="d-none d-md-block">
            <Row>
              <Col sm={2}>
                <span>Name</span>
              </Col>
              <Col sm={2}>
                <span>Size</span>
              </Col>
              <Col sm={2}>
                <span>Type</span>
              </Col>
              <Col sm={2}>Date Modified</Col>
            </Row>
          </ListGroup.Item>
          {docs.map((doc) => (
            <ListGroup.Item key={doc.id} className="">
              <Row>
                <Col md={2}>
                  <span>
                    {doc.name.length > 10
                      ? doc.name.substring(0, 14) + "..."
                      : doc.name}
                  </span>
                </Col>
                <Col md={2}>
                  <span>{doc.fileSize} Mb</span>
                </Col>
                <Col md={2}>
                  <span>{doc.type ? doc.type : "unknown"}</span>
                </Col>
                <Col md={2}>
                  <span>{doc.date}</span>
                </Col>
                <Col md={2}>
                  <a href={doc.url} target="_blank" download>
                    <Button
                      type="button"
                      variant="primary"
                      style={{ marginBottom: "7px" }}
                    >
                      View / Download
                    </Button>
                  </a>
                </Col>
                <Col md={2}>
                  <Button
                    type="button"
                    variant="danger"
                    onClick={() => handleDelete(doc.url, doc.id)}
                  >
                    Delete
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </>
  );
};

export default ListComp;
